<template>
  <ui-dropdown
    class="is-right"
    :options="options"
    :value="value"
    @change="onChange"
  />
</template>

<script>
  import Ui from 'services/Ui'

  export default {

    computed: {
      options () {
        return Ui.getOptions('time.filters')
      },

      value: {
        get () {
          return this.$store.state.params.days

        },
        set (value) {
          if (this.value !== value) {
            this.$store.commit('params/days', value);
          }
        }
      },
    },

    methods: {
      onChange(value) {
        this.value = value
      }
    }
  }
</script>

<style scoped>

</style>